import { MyOrdersResponse, MyOrdersItem } from "./my-orders-response";

/**
 * Renders a table row for an order item.
 * @param myOrdersItem - The item from the orders list.
 * @param multipleMachinesResponse - Optional parameter containing machine details.
 * @returns A string representing a table row.
 */
const renderOrderRow = (
    myOrdersItem: MyOrdersItem,
    multipleMachinesResponse?: MyOrdersResponse["multipleMachines"]
): string => {
    // Destructuring with null checks
    const {
        orderNumber = "",
        status = { text: "", type: "" },
        date = "",
        entryPoint = "",
        position = "",
        orderSum = "",
        machineNumber = "",
        detailLink = "",
    } = myOrdersItem || {};

    // Fallback for multipleMachinesResponse
    const { label = "", tooltipContent = "" } = multipleMachinesResponse || {};

    return `
    <tr>
        <td>${orderNumber}</td>
        <td>${renderProductionStatusLabel(status.text, status.type)}</td>
        <td>${date}</td>
        <td>${entryPoint}</td>
        <td>${position}</td>
        <td>${orderSum}</td>
        <td>${renderMachineInfo(label, tooltipContent, machineNumber)}</td>
        <td><ux-button size="icon" icon="chevron-right" title="next" href="${detailLink}"></ux-button></td>
    </tr>
    `;
};

/**
 * Renders the production status label.
 * @param labelText - The text for the label.
 * @param type - The type of label.
 * @returns A string representing an HTML element for the label.
 */
const renderProductionStatusLabel = (
    labelText: string,
    type: string
): string => {
    return `<ux-iws-status-label type="${type}">${labelText}</ux-iws-status-label>`;
};

/**
 * Renders machine information, handling both single and multiple machines.
 * @param label - The label for the machine section.
 * @param tooltipContent - The content for the tooltip.
 * @param machineNumber - The machine number or array of numbers.
 * @returns A string representing an HTML element for machine information.
 */
const renderMachineInfo = (
    label: string,
    tooltipContent: string,
    machineNumber: string | string[]
): string => {
    if (Array.isArray(machineNumber) && machineNumber.length > 1) {
        const paragraphs = machineNumber.map(
            (item) => `<p class="ux-text-normal ux-u-my-zero">${item}</p>`
        );
        const combinedHtml = paragraphs.join("");
        return `<div class="ux-u-d-flex ux-u-flex-ai-center"><span>${label}</span><ux-icon name="info" class="ux-u-ml-xxxs"></ux-icon><ux-tooltip tooltip-target="ux-icon[name='info']" align="top"><p class="ux-text-normal ux-u-my-zero">${tooltipContent}</p><br/>${combinedHtml}</ux-tooltip></div>`;
    } else {
        return `<span>${machineNumber}</span>`;
    }
};

export default renderOrderRow;
